import { createAction, createReducer } from 'redux-act';
import { IPskResponse } from '../../../types/psk';

export type IState = {
    psk: IPskResponse;
};

const initialState: IState = {
    psk: {},
};

export const setPSk = createAction<IPskResponse>('marketplace/psk/set');

export const pskSlice = createReducer((on) => {
    on(setPSk, (state, payload) => ({
        ...state,
        psk: payload,
    }));
}, initialState);
